import { TasksDetailsAttachmentsPage } from '@rtkwlf/c3-feature-tasks';

import { useOrganizationParam } from '@packages/hooks/use-organization-param';

import { useTaskIdParam } from '../hooks/use-task-id-param';

export const TasksDetailsAttachmentsRoute = () => {
  /**
   * Get the organizationID from the url
   */
  const orgID = useOrganizationParam();

  /**
   * Get taskId from the url
   */
  const taskId = useTaskIdParam();

  return <TasksDetailsAttachmentsPage orgId={orgID} taskId={taskId} />;
};
